import React, { useState, useEffect } from 'react'
import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonItem, IonLabel, IonInput, IonCol, IonRow, IonButton } from '@ionic/react'
import { useRouter } from '../../resources/Hooks'
import db from '../../resources/db'
import { toastController } from '@ionic/core'
import { APPLINKS } from '../../resources/AppConst'

const UpdateCustomer = (props) => {
    
    const {customerContact, customerDetails , customerGST , customerName} = props.data
    const [Customer, setCustomer] = useState({})
    const router = useRouter()
    // console.log(Customer);
    useEffect(() => {
        setCustomer({ customerContact, customerDetails, customerGST, customerName})
    }, [customerContact, customerDetails, customerGST, customerName])
    
    const updateCustomer = async (data) => {
       await db.ledger.where("customerName").equals(props.data.customerName).modify(data).then((res) => {
           console.log('Updated Customer Data, ' + res);
           toastController.create({
               color: 'success',
               duration: 2000,
               message: `Customer data Updated successfully`,
               showCloseButton: true
           }).then(toast => {
               toast.present();
           });
        })

        await db.invoices.where("customerName").equals(props.data.customerName).modify(data).then(res => {
            console.log('Biils Updated ,', res)
        })
        props.setData(data)
    }

    const onSubmit = async (e) => {
        e.preventDefault()
        props.setModelOpen(false)
        console.log(Customer);
        await updateCustomer(Customer)
        router.push(`${APPLINKS.ledger}/${btoa(Customer.customerName)}`)
    }

    return (
        <IonCard>
            <IonCardHeader>
                <IonCardTitle>Update Customer Details</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                <form onSubmit={onSubmit}>
                    <IonRow>
                        <IonCol>
                            <IonItem>
                                <IonLabel position='stacked'>Name</IonLabel>
                                <IonInput required type='text' id='customerName' value={Customer.customerName} onIonInput={e => { setCustomer({...Customer , customerName: (e.target.value).trim()}) }}></IonInput>
                            </IonItem>
                            <IonItem>
                                <IonLabel position='stacked'>Contact</IonLabel>
                                <IonInput type='text' id='customerContact' value={Customer.customerContact} onIonInput={e => { setCustomer({ ...Customer, customerContact: (e.target.value).trim() }) }}></IonInput>
                            </IonItem>
                            <IonItem>
                                <IonLabel position='stacked'>Customer Details</IonLabel>
                                <IonInput type='text' id='customerDetails' value={Customer.customerDetails} onIonInput={e => { setCustomer({ ...Customer, customerDetails: (e.target.value).trim() }) }}></IonInput>
                            </IonItem>
                            <IonItem>
                                <IonLabel position='stacked'>Customer GST</IonLabel>
                                <IonInput type='text' id='customerGST' value={Customer.customerGST} onIonInput={e => { setCustomer({ ...Customer, customerGST: (e.target.value).trim() }) }}></IonInput>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonButton color='danger' type='submit'>Submit</IonButton>
                </form>
            </IonCardContent>
        </IonCard>
    )
}

export default UpdateCustomer
